import { Markdown } from '@components/markdown'
import { ActionButton } from '@contentful-components/action-button'
import type { BentoPieceSquareCounterFragment } from '@graphql/queries/GetBentoPieceSquareCounter.graphql'
import { isGradientColor } from '@lib/utils/isGradientColor'
import variables, { type Variable } from '@styles/variables'
import type { FunctionComponent } from 'react'

import styles from './bento-square-counter.module.scss'

export const BentoSquareCounter: FunctionComponent<Props> = ({
    smallerVersion = false,
    counter = '',
    heading = '',
    subtitle = '',
    backgroundColor = 'darkGray',
    button,
}) => {
    function getBackgroundStyle() {
        if (isGradientColor(backgroundColor)) {
            return { background: variables[backgroundColor as Variable] }
        }

        return { backgroundColor: variables[backgroundColor as Variable] }
    }

    return (
        <div className={styles.boxOne} style={getBackgroundStyle()}>
            <div className={styles.boxOneContent}>
                <div className={styles.boxOneCopy}>
                    <div
                        className={`${styles.number} ${
                            styles.headinggradient
                        } ${smallerVersion ? styles.smallerVersion : ''}`}
                    >
                        {counter}
                    </div>

                    <div className={styles.copy}>
                        <div
                            className={`${styles.heading} ${
                                smallerVersion ? styles.smallerVersion : ''
                            }`}
                        >
                            <Markdown
                                tag='p'
                                typeStyle={{
                                    _: 'heading-xs',
                                    md: 'heading-sm',
                                }}
                                markdown={heading}
                            />
                        </div>
                        <div className={styles.subtitle}>
                            <Markdown
                                tag='p'
                                typeStyle={{ _: 'body-lg', md: 'body-md' }}
                                markdown={subtitle}
                            />
                        </div>
                        {button?.title && (
                            <div className={styles.button}>
                                <ActionButton {...button} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BentoSquareCounter

type Props = Omit<BentoPieceSquareCounterFragment, 'sys' | 'type'> & {
    index?: number
    button?: object
}
